import { useTranslation } from 'react-i18next';
import { renderIcon } from '@/utils/iconRenderer';

export default function DateSelectionButton({ onClick }) {
    const { t } = useTranslation();

    return (
        <button onClick={onClick} className="relative p-2 text-gray-500">
            {renderIcon('date', 24, "text-color-text")}
            <span className="sr-only">{t('Tarih Seç')}</span>
        </button>
    );
}
